import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    contacts: translate({ id: 'gps.alerts.alertContacts' }),
    sms: translate({ id: 'global.sms' }),
    email: translate({ id: 'global.email' }),
  }))

  return api
}
